// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1ECqe","list":"PatternAutocomplete_list__fu3RW"};